import React from "react";
import T from "prop-types";
import { connect } from "react-redux";
import { Field } from "redux-form";
import { Col } from "react-bootstrap";
import {
  Check,
  CheckGroup,
  form,
  Form as AppForm,
  FormInput
} from "MODULES/shared/components/Forms";
import * as actions from "MODULES/Lots/actions";
import { ACCOUNTING, ADMIN, ROLE, USER } from "MODULES/users/constants";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import {
  AMOUNT_PAID,
  INVOICE_DUE_DATE,
  INVOICE_NUMBER,
  INVOICE_PAID_DATE
} from "MODULES/Lots/constants";
import { properCase } from "LIB/formatters/text";
import withLot from "MODULES/Lots/decorators/withLot";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";

export function Form(props) {
  const setToFull = (_ev, val) => {
    if (val) {
      props.setFieldValue(AMOUNT_PAID)(props.cost);
      // Get today's date in yyyy-mm-dd format
      const today = new Date().toISOString().split("T")[0];
      props.setFieldValue(INVOICE_PAID_DATE)(today);
    }
  };

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormRow>
          <Col md={6}>
            <Field
              name={INVOICE_NUMBER}
              component={FormInput}
              label="Invoice #"
            />
          </Col>
          <Col md={6}>
            <Field
              name={INVOICE_DUE_DATE}
              component={FormInput}
              type="date"
              label="Invoice Due Date"
            />
          </Col>
        </FormRow>
        <FormRow>
          <Col md={3}>
            <Field
              name={AMOUNT_PAID}
              component={FormInput}
              type="number"
              label={properCase(AMOUNT_PAID)}
            />
          </Col>
          <Col md={3}>
            <CheckGroup justified title="Amt Paid In Full">
              <Field
                name="paid_in_full"
                component={Check}
                label="Yes"
                onChange={setToFull}
              />
            </CheckGroup>
          </Col>
          <Col md={6}>
            <Field
              name={INVOICE_PAID_DATE}
              component={FormInput}
              type="date"
              label="Invoice Paid"
            />
          </Col>
        </FormRow>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  isLastExchange: T.bool,
  nonAccountingUser: T.bool
};

export default connect(
  state => ({
    nonAccountingUser: ![ACCOUNTING, ADMIN].includes(
      state.session.getIn([USER, ROLE])
    )
  }),
  {
    onSubmit: actions.update
  }
)(
  withLot(
    form({
      form: "lotBillingForm"
    })(withFieldAccessors(Form))
  )
);



// WEBPACK FOOTER //
// ./app/modules/Lots/Detail/Billing/Form.jsx